import React, { ReactElement } from 'react'
import { PublicUserConnectionType } from 'lib/graphql/graphqlTypes'
import PublicUsersList from 'modules/common/components/PublicUserList'
import strings from 'lib/constants/strings'

/**
 * 5.0.6.4 Profile - Network - Recommended Users
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3247%3A5776
 *
 *  fields:
 *  user  lastName
 *  user  firstName
 *  user  staff
 *  user  imageUrl
 *  user  jobTitle
 */

const RecommendedUsers = (): ReactElement => (
  <PublicUsersList
    title={strings.PROFILE.NETWORK.SUGGESTED_USERS_TITLE}
    subtitle={strings.PROFILE.NETWORK.SUGGESTED_USERS_SUBTITLE}
    queryInput={{
      pageSize: 12,
      page: 1,
      limit: 24,
      filters: {
        type: PublicUserConnectionType.RECOMMENDED,
      },
    }}
  />
)

export default RecommendedUsers
